import { Footer } from "../Footer"
import { Header } from "../Header"

export const Guide = () => {
    return(
        <div style={{minHeight: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center'}}>
            <h1>Guide</h1>

            <section>
                <h2></h2>
               
            </section>
        </div>
    )
}